// general identifiers
export const CUSTOMER_ID = 'ingg';

// markets identifiers
export const TO_WIN_CODE = 1;
export const PLACE_CODE = 2;
export const SHOW_CODE = 3;
export const FORECAST_CODE = 5;
export const TRICAST_CODE = 6;
export const REVERSE_FORECAST_CODE = 7;
export const REVERSE_TRICAST_CODE = 8;

// virtual sports identifiers
export const HORSES = 0;
export const HORSES_SPRINTS = 64;
export const DOGS = 1;
export const CITY_DOGS = 65;
export const SPEEDWAY = 2;
export const MOTOR_RACING = 3;
export const UNKNOWN = 4; // TODO: WE STILL DONT KNOW WHAT IS WHAT...
export const NUMBERS = 5;
export const TROTTING = 6;
export const CYCLING = 7;
export const TENIS = 8;
export const FOOTBALL = 9;
export const SOCCER3_FOOTBALL = 40;
export const FIRST_DOWN = 22;
export const BASKET_BALL = 26;
export const BASKET_BALL_EURO = 27;
export const BASKET_BALL_NBA = 71;
export const NFLA = 32;
export const AF_H2H = 25;
export const MARBLES = 30;
export const MATCHDAY = 36;
export const CRICKET = 17;
export const TENNIS = 56
export const BASEBALL = 47
export const NFL = 69

// football sub markets
export const HOME = 'Home';
export const AWAY = 'Away';
export const BOTH = 'Both';

// ui module indetifier
export const SPORTS_BOOK_MODULE = 'SPORTS_BOOK_MODULE';
export const SIMPLIFIED_MODULE = 'SIMPLIFIED_MODULE';

// module identifiers
export const RACING_MODULE = 'RACING_MODULE';
export const FOOTBALL_MODULE = 'FOOTBALL_MODULE';
export const BASKETBALL_MODULE = 'BASKETBALL_MODULE';
export const AMERICAN_FOOTBALL_MODULE = 'AMERICAN_FOOTBALL_MODULE';
export const FIRST_DOWN_MODULE = 'FIRST_DOWN_MODULE';
export const MATCHDAY_MODULE = 'MATCHDAY_MODULE';
export const CRICKET_MODULE = 'CRICKET_MODULE';
export const TENNIS_MODULE = 'TENNIS_MODULE'
export const BASEBALL_MODULE = 'BASEBALL_MODULE'

// Bet Slip Modal Screen
export const BET_SLIP = 'BET_SLIP';
export const OPEN_BETS = 'OPEN_BETS';
export const PLACED_BETS = 'PLACED_BETS';
export const SETTLED_BETS = 'SETTLED_BETS';
export const BET_HISTORY = 'BET_HISTORY';

// Modal screen types
export const SETTINGS_MODAL_TYPE = 'SETTINGS_MODAL_TYPE';
export const HELP_PAGE_MODAL_TYPE = 'HELP_PAGE_MODAL_TYPE';
export const REALITY_CHECK_MODAL_TYPE = 'REALITY_CHECK_MODAL_TYPE';
export const CHIPS_LIST_MODAL_TYPE = 'CHIPS_LIST_MODAL_TYPE';
export const NOTIFICATION_MODAL_TYPE = 'NOTIFICATION_MODAL_TYPE';
export const LIST_NOTIFICATION_MODAL_TYPE = 'LIST_NOTIFICATION_MODAL_TYPE';
export const SET_VIDEO_FULL_SCREEN_CONFIRMATION = 'SET_VIDEO_FULL_SCREEN_CONFIRMATION';
export const MY_OFFER_LIST_MODAL_TYPE = 'MY_OFFER_LIST_MODAL_TYPE';

// Call back function types
export const CLOSE_BUTTON_CALL_BACK_TYPE = 'CLOSE_BUTTON_CALL_BACK_TYPE'

// Notification types
export const ALERT_NOTIFICATION = 'ALERT_NOTIFICATION';
export const WARNING_NOTIFICATION = 'WARNING_NOTIFICATION';
export const INFO_NOTIFICATION = 'INFO_NOTIFICATION';
export const SUCCESS_NOTIFICATION = 'SUCCESS_NOTIFICATION';

//Odds types
export const DECIMAL = 'DECIMAL';
export const FRACTIONAL = 'FRACTIONAL';
export const AMERICAN = 'AMERICAN';
export const SUPPORTED_UI_ODDS_FORMAT = [DECIMAL, FRACTIONAL, AMERICAN];

//Bet states
export const PLACED = 'PLACED';
export const SETTLED = 'SETTLED';
export const VOIDED = 'VOIDED';
export const SETTLED_IN_HISTORY = 'SETTLED_IN_HISTORY';

//game states
export const PRE = 'PRE';
export const NMB = 'NMB';
export const VID = 'VID';
export const RES = 'RES';

export const ENABLED = 'ENABLED';
export const SOFT_SUSPENDED = 'SOFT_SUSPENDED';
export const HARD_SUSPENDED = 'HARD_SUSPENDED';

// HTML VIDEO IFRAME ID
export const HTML_VIDEO_IFRAME_ID = 'video-iframe';
// Manchester video player id
export const HTML_VIRTUALS_VIDEO_PLAYER_ID = '__inggPlayer';
export const HTML_VIRTUALS_VIDEO_MUTE_ID = '__inggPlayerFirstTime';

export const GOLD = 'XAU';
export const SILVER = 'XAG';
export const JPY = 'JPY';
export const TRY = 'TRY';
export const XXX = 'XXX';
export const RSD = 'RSD';
export const MAD = 'MAD';
export const COP = 'COP';
export const KES = 'KES';
export const GHS = 'GHS';
export const NGN = 'NGN';
export const SEK = 'SEK';

//event time display mode
export const CURRENT_NEXT = 'CURRENT_NEXT';
export const SINGLE = 'SINGLE';
export const ACCUMULATOR = 'ACCUMULATOR';

//lobby button position.
export const LOBBY_BUTTON_LEFT = 'LEFT';
export const LOBBY_BUTTON_RIGHT = 'RIGHT';

//channel name
//TODO; Needs to remove it with the event type ID
export const VPP_MATCHDAY_ENGLISH_CHANNEL = 'VPP_Matchday_English';
export const VPP_MATCHDAY_TURKISH_CHANNEL = 'VPP_Matchday_Turkish';
export const VPP_MATCHDAY_GREEK_CHANNEL = 'VPP_Matchday_Greek';
export const VPP_MATCHDAY_MOROCCAN_CHANNEL = 'VPP_Matchday_Moroccan';
export const VPP_MATCHDAY_BELGIUM_CHANNEL = 'VPP_Matchday_Belgium';
export const VPP_MATCHDAY_LIGHT_ENGLISH_CHANNEL = 'VPP_Matchday_Light_English';

//TODO; this should be removed once we receive controller status through Porthole.
export const VPP_MOTORRACING_STOCKCARS_CHANNEL = 'VPP_MotorRacing_StockCars';
export const VPP_AMERICANFOOTBALL_USLEAGUE_CHANNEL = 'VPP_AmericanFootball_USLeague';
//promo tool
//to identify real bet and promo bet
export const VPP_REAL_BET = 'real_bet';

//channel name for basketball NBA
export const VPP_BASKETBALL_NBA ='VPP_Basketball_NBA';


// WEBPACK FOOTER //
// ./src/constants/identifiers.js